import React from 'react'
import Router from 'next/router'
import { WidgetCard } from '@components/Widgets/Common'
import {
  ProfessionalCourseContent,
  ProfessionalCourseDesc,
  ProfessionalCourseItem,
  ProfessionalCourseList,
  ProfessionalCourseTitle,
  ProfessionalHeader,
  ProfessionalIconImage,
  ProfessionalIconWrapper,
  ProfessionalTitle,
  ProfessionalViewAll
} from './style'


const ProfessionalCourses: React.FC = () => {
  const courses = [
    {
      title: 'AI Literacy and Compliance Training',
      description: 'Boost strategic growth with our AI Literacy & Compliance training for business development.',
      icon: '/images/AiIcon.svg',
      redirectUrl: '/learning-path#Professional+Development'
    },
    /*{
      title: 'How to Behave Successfully in Negotiations',
      description: 'Master win-win negotiations with our success-driven training for strategic growth.',
      icon: '/images/Handshake.svg',
    },
    {
      title: 'Presenting with Confidence',
      description: 'Master high-impact presenting to win stakeholders and drive strategic growth.',
      icon: '/images/Presenting.svg',
    },*/
  ]

  const handleViewAllClick = () => {
    Router.push('/learning-path#Professional+Development')
  }
  const redirectClick = (abc) => {
    Router.push(abc)
  }
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768

  return (
    <WidgetCard
      dataPermission="c::dashboard::ProfessionalCourses"
      customStyling={{
        padding: '16px',
        paddingTop: isMobile ? '0' : '16px',
        background: '#E5EDFD',
        height: '100%'
      }}
    >
      <div className="professional-courses-card">
        <ProfessionalHeader>
          <ProfessionalTitle>
            New Professional Development courses available!
          </ProfessionalTitle>
          {courses.length > 1 && (
            <ProfessionalViewAll onClick={handleViewAllClick}>
              View all &gt;
            </ProfessionalViewAll>
          )}
        </ProfessionalHeader>
        <ProfessionalCourseDesc>
          Elevate your career with our new Professional Development courses. Master the art of strategic growth, partnership building, and value creation to drive long-term success for any organization.
        </ProfessionalCourseDesc>
        <ProfessionalCourseList>
          {courses.map((course, index) => (
            <ProfessionalCourseItem key={index}>
              <ProfessionalIconWrapper>
                <ProfessionalIconImage src={course.icon} />
              </ProfessionalIconWrapper>
              <ProfessionalCourseContent>
                <ProfessionalCourseTitle onClick={() => redirectClick(course.redirectUrl)}>
                  {course.title} &gt;
                </ProfessionalCourseTitle>
                <ProfessionalCourseDesc>
                  {course.description}
                </ProfessionalCourseDesc>
              </ProfessionalCourseContent>
            </ProfessionalCourseItem>
          ))}
        </ProfessionalCourseList>
      </div>
    </WidgetCard>
  )
}

export default ProfessionalCourses